
const ENV = process.env.NODE_ENV
export default {
  DOMAIN: 'http://127.0.0.1:8080',
  // baseURL: ENV == 'development'?'http://127.0.0.1:8080':'127.0.0.1:8080',
  // baseURL: "http://mu.eguowang.com",
  // imageURL: "http://mu.eguowang.com",
  baseURL: "https://api.edujgz.com",
  imageURL: "https://api.edujgz.com",
  util: {
    image: '/util/image.html' // 图片上传
  }
}



// WEBPACK FOOTER //
// ./src/api/api.url.js